import React, { Children, useContext } from "react";

import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
    useParams
} from "react-router-dom";

import LoginPage from './Pages/LoginPage';
import HomePage from './Pages/HomePage/index.jsx';
import EnviaReset from './Pages/LoginPage/enviaReset.jsx';
import ResetSenha from './Pages/Usuarios/resetsenha.jsx';
import Unidade from "./Pages/Unidade/unidade";
import BoletimPlus from "./Pages/Notas/lista_alunos.jsx";
import PaginaNotas from "./Pages/Notas/notas.jsx";
import Ranking_Alunos_Serie from "./Pages/Modulos/ranking_alunos_unidade.jsx";
import Ranking_Alunos_Serie_Bolsa from "./Pages/Modulos/ranking_alunos_unidade_bolsa.jsx";
import Ranking_Alunos_Serie_BolsaTS from "./Pages/Modulos/ranking_alunos_unidade_bolsaTS.jsx";
import Ranking_Alunos_Serie_BolsaBT from "./Pages/Modulos/ranking_alunos_unidade_bolsaBT2.jsx";
import Ranking_Series_Unidade from "./Pages/Modulos/ranking_unidades_series2.jsx";
import DesempenhoPorFaixa from "./Pages/Modulos/Qtd_Alunos_faixa_desempenho.jsx";


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider, AuthContext } from "./contexts/auth";

const AppRoutes = () => {
    const Private = ({ children }) => {
        const { authenticated, loading } = useContext(AuthContext);

        if (loading) {
            return <div className="loading">Carregando...</div>;
        }
        if (!authenticated) {
            return <Navigate to="/login" />
        }
        return children;
    }

    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route exact path="/login" element={<LoginPage />} />
                    <Route exact path="/enviaReset" element={<EnviaReset />} />
                    <Route exact path="/" element={<Private><HomePage /></Private>} />
                    <Route exact path="/resetSenha/:token" element={<ResetSenha />} />
                    <Route exact path="/unidade/:cod_unidade" element={<Private> <Unidade /> </Private>} />
                    <Route exact path="/boletimplus/:cod_unidade" element={<Private> <BoletimPlus /></Private>} />
                    <Route exact path="/boletimplusAluno/:matricula_aluno" element={<Private> <PaginaNotas /></Private>} />
                    <Route exact path="/ranking" element={<Private> <Ranking_Alunos_Serie_BolsaBT /></Private>} />
                    <Route exact path="/ranking-series" element={<Private> <Ranking_Series_Unidade /></Private>} />
                    <Route exact path="/desempenho-faixa" element={<Private> <DesempenhoPorFaixa /></Private>} />

                    {/* <Route exact path="/rankingbolsa" element={<Private> <Ranking_Alunos_Serie_BolsaBT /></Private>} />
                    <Route exact path="/rankingbolsaTS" element={<Private> <Ranking_Alunos_Serie_BolsaTS /></Private>} />
                    <Route exact path="/rankingbolsaBT" element={<Private> <Ranking_Alunos_Serie_BolsaBT /></Private>} /> */}


                </Routes>
                <ToastContainer />
            </AuthProvider>

        </Router>

    )
}

export default AppRoutes;